import { GET_CLIENT, LOAD_ADDRESS, UPDATE_ADDRESS } from "../actions/types";

const initialState = {
  loadedAddress: {},
  newAddress: {},
};

export default function (state = initialState, action) {
  let companies = state.companies;
  switch (action.type) {
    case LOAD_ADDRESS:
      return {
        ...state,
        loadedAddress: action.payload.contactInfo,
      };
    case UPDATE_ADDRESS:
      return {
        ...state,
        newAddress: action.payload.newAddress,
      };

    default:
      return state;
  }
}
